export default "__VITE_ASSET__15437833__"